module.exports = __webpack_public_path__ + "img/done-note.cb09affa.svg";